<template>
  <div id="consulta d-flex flex-row flex-wrap justify-content-center">
    <Header :logged="logged" />

    <b-modal
      ref="modalInstrumento"
      size="xl"
      scrollable
      title="Instrumento de Protesto"
      id="modal-dialog"
      @show="desableRC"
    >
      <pdf :src="pdf" style="width:100%"></pdf>
    </b-modal>

    <b-modal ref="modalErro" title="Atenção">Nenhum registro encontrado</b-modal>
    <div id="wrapper-spinner" v-if="exibir">
      <BeatLoader color="var(--main-azul)" />
    </div>

    <div id="consulta-form" class="d-sm-none d-md-block column-nowrap" v-if="!exibir">
      <section class="container nowrap">
        <div id="banner1" class="item"></div>
      </section>
      <div id="rodape" class="text-center">
        <h1 class="mt-3 letraConsProt">Verificação de autenticidade de Instrumento de Protesto</h1>
        <div id="wrapper-input" class="mt-4">
          <div id="bt-consultar" class="text-center" @click="enviarConsulta()">VERIFICAR</div>
          <div id="wrapper-cpf_cnpj">
            <div id="cpf_ou_cnpj" @click="inputConsultaFocus()">Chave Única</div>
            <the-mask
              :mask="['#######################']"
              id="cpf_cnpj"
              v-model="cpf_cnpj"
              v-on:keyup.native="verificaInputConsulta()"
              @focus.native="placeholderInputConsulta(false)"
              class="vtm"
            />
          </div>
        </div>
      </div>
      <vue-recaptcha
        ref="invisibleRecaptcha"
        @verify="onVerify"
        @expired="onExpired"
        size="invisible"
        :sitekey="sitekey"
      ></vue-recaptcha>
    </div>
  </div>
</template>

<script>
import { TheMask } from "vue-the-mask";
import Header from "../components/Header";
import API from "../services/api";
import BeatLoader from "vue-spinner/src/BeatLoader.vue";
import pdf from "vue-pdf";
import VueRecaptcha from "vue-recaptcha";

export default {
  components: {
    TheMask,
    Header,
    BeatLoader,
    pdf,
    VueRecaptcha
  },
  data() {
    return {
      sitekey: process.env.VUE_APP_sitekeyRecaptcha,
      cpf_cnpj: "",
      logged: false,
      documento: "",
      pdf: "",
      tok: "",
      exibir: false
    };
  },
  mounted() {
    this.$root
      .isLogged()
      .then(() => {
        this.logged = true;
      })
      .catch(() => {
        this.logged = false;
      });
  },
  methods: {
    //desableRC: function(e) {
    onVerify: function(response) {
      this.tok = response;
      //console.log(response);
      this.$refs.invisibleRecaptcha.reset();
      if (this.cpf_cnpj) {
        this.exibir = true;
        API.get(`VerifInstProt/${this.cpf_cnpj}/${this.tok}`)
          .then(res => {
                if(res.data.result == 1){
                    this.pdf =
                    "data:application/pdf;base64," + res.data.instrumentoProtesto;
                    this.$refs["modalInstrumento"].show();
                    this.exibir = false;
                }else {
                    this.$refs["modalErro"].show();
                    this.exibir = false;
                }
          })
          .catch(()=> {
            //console.log(e);
            alert("Não foi possivel completar a solicitação");
            this.exibir = false;
          });
      }
      this.resetRecaptcha();
    },
    onExpired: function() {
      this.$refs.invisibleRecaptcha.reset();
    },
    resetRecaptcha() {
      this.$refs.invisibleRecaptcha.reset(); // Direct call reset method
    },
    desableRC() {
      var body = document.getElementsByTagName("body")[0];
      body.setAttribute("oncontextmenu", "return false");
    },
    enviarConsulta() {
      this.$refs.invisibleRecaptcha.execute();
    },
    validar() {
      let len = this.cpf_cnpj.length;
      //let doc = this.cpf_cnpj
      return len == 11 || len == 14 ? true : false;
      //return len == 11 ? Serv.validarCPF(doc) : len == 14 ? Serv.validarCNPJ(doc) : false
    },
    placeholderInputConsulta(show) {
      let placeholder = document.getElementById("cpf_ou_cnpj");
      if (show) placeholder.classList.remove("hide");
      else placeholder.classList.add("hide");
    },
    verificaInputConsulta() {
      let wrapperInputStyle = document.getElementById("cpf_cnpj").style;
      //console.log(this.cpf_cnpj.length);
      if (this.cpf_cnpj.length !== 23 || this.cpf_cnpj.length == 0) {
        //wrapperInputStyle.border = "2px solid rgb(255,255,255)";
        wrapperInputStyle.color = "rgb(255,0,0)";
        if (this.cpf_cnpj.length == 23) return true;
        else return false;
      } else {
        wrapperInputStyle.color = "rgb(255,255,255)";
        return false;
      }
      //return this.cpf_cnpj.length == 23 ? true : false;
    },
    inputConsultaFocus() {
      document.getElementById("cpf_cnpj").focus();
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 40px;
}
h1,
p,
p b {
  color: #fff;
}
p {
  font-size: 17px;
}
p > b {
  margin-right: 15px;
}
#wrapper-spinner {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: calc(100% - 80px);
}
#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}
#consulta-form {
  font-family: "Kanit", sans-serif !important;
}
#banner1 {
  background-image: url("~@/assets/imgs/7.jpg");
  max-width:100%;
	height:auto;
  margin-top: -132px;
}
.containerB {
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  border: 1px solid #ccc;
  height: 100%;
  position: absolute;
  /* margin-top: 579px; */
  width: 100%;
}
.container {
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  height: 100%;
  padding-right: 0px;
  padding-left: 0px;
  position: absolute;
}
.nowrap {
  flex-wrap: nowrap;
}
.column-nowrap {
  flex-flow: column nowrap;
}
#wrapper-input {
  background-color: rgba(255, 255, 255, 0.3);
  border: 2px solid rgb(255, 255, 255) !important;
  width: 52%;
  height: 28%;
  margin-left: 25%;
  position: absolute;
  z-index: 10;
}
#cpf_ou_cnpj {
  position: absolute;
  left: 15px;
  bottom: 15px;
  font-size: 19px;
  letter-spacing: 0.25px;
  color: #fff;
  opacity: 1;
  transition: all 0.8s ease-out;
}
#cpf_ou_cnpj.hide {
  bottom: 0px;
  opacity: 0;
}
#cpf_cnpj {
  width: 100%;
  height: 210%;
  background: none;
  color: #fff;
  border: none;
 font-family: "Kanit", sans-serif !important;
  font-size: 32px;
  letter-spacing: 2px;
}
#bt-consultar {
  cursor: pointer;
  float: right;
  width: 45%;
  height: 84%;
  color: #fff;
  background-color: #de8800;
 font-family: "Kanit", sans-serif !important;
  font-size: 30px;
  margin-right: 8px;
  margin-top: 4px;
}
#wrapper-cpf_cnpj {
  padding: 10px 0px 10px 10px;
  position: absolute;
  width: 54%;
  height: 70% !important;
}
.itemB {
  flex: 1;
  text-align: center;
  font-size: 1.5em;
}
.item {
  /* O flex: 1; é necessário para que cada item se expanda ocupando o tamanho máximo do container. */
  flex: 1;
  text-align: center;
  font-size: 1.5em;
}
.space-around {
  justify-content: space-around;
}
.column {
  min-height: 100%;
  flex-direction: column;
}
.flex {
  flex: 1;
}
.itemB1 {
  background-color: rgba(20, 96, 118, 0.75);
}
.itemB2 {
  background-color: rgba(20, 96, 118, 0.75);
}
.itemB3 {
  background-color: #146076;
}
.itemConsulta {
  background-color: rgba(20, 96, 118, 0.75);
}
#rodape {
  background-color: #185684;
  width: 100%;
  height: 229px;
  position: absolute;
  z-index: 10;
  bottom: 0;
  margin-bottom: 0;
}
#rodapeV {
  background-color: #185684;
  width: 100%;
  height: 227px;
  position: absolute;
  z-index: 10;
  bottom: 0;
  margin-bottom: 0%;
}
.text-amarelo {
  color: #ffa20e;
}
.letraInstProt {
  font-size: 28px;
}
.letraAtencao {
  font-size: 38px;
}
@media (min-width: 320px) and (max-width: 765px) {
  h1 {
    font-size: 22px;
}
  #banner1 {
    background-image: url("~@/assets/imgs/12.jpg");
    background-repeat: no-repeat;
    height: 546px;
    margin-top: 80px;
    margin-left: -119px;
    max-width: 133%;

}
  #consulta {
    width: 100%;
    background-image: url("~@/assets/imgs/7.jpg") !important;
    background-size: cover;
    background-attachment: scroll;
    height: 100vh;
    overflow: hidden;
    top: 0;
    left: 0;
    /* Preserve aspect ratio */
    min-width: 100%;
    min-height: 100%;
    position: fixed;
}
  #rodapeV {
    height: 234px;
}
  #bt-consultar {
    width: 100%;
    height: 50%;
    font-size: 16px;
    margin-right: 0%;
    margin-top: 37px;
}
  #cpf_ou_cnpj {
    font-size: 19px;
}
  .letraInstProt {
    font-size: 18px;
}
  .letraAtencao {
    font-size: 22px;
}
  #cpf_ou_cnpj {
    font-size: 18px;
    bottom: 20px;
}
#wrapper-input {
    width: 90% !important;
    height: 33% !important;
    margin-left: 5% !important;
}
#cpf_cnpj {
    font-size: 17px;
    margin-top: -14px;
    height: 100%;
}
#wrapper-cpf_cnpj {
    width: 100%;
    height: 70% !important;
  }
}
@media (min-width: 766px) and (max-width: 900px) {
#wrapper-input {
    height: 22%;
    margin-left: 7%;
    width: 86%;
}
#consulta {
    width: 100%;
    background-image: url("~@/assets/imgs/7.jpg") !important;
    background-size: cover;
    background-attachment: scroll;
    height: 100vh;
    overflow: hidden;
    top: 0;
    left: 0;
    /* Preserve aspect ratio */
    min-width: 100%;
    min-height: 100%;
}
#banner1 {
    background-image: url("~@/assets/imgs/7.jpg");
    max-width: 100%;
    height: auto;
    width: 100% !important;
    }
}
@media (min-width: 1200px) and (max-width: 1600px) {
#banner1 {
    background-image: url("~@/assets/imgs/7.jpg");
    height: 966px;
}
#wrapper-input {
    border: 2px solid rgb(255, 255, 255) !important;
    width: 71%;
    height: 28% !important;
    margin-left: 15%;
  }
}
.vtm {
    border: none;
    outline-offset: 0px;
    outline: 0px auto -webkit-focus-ring-color;
}
</style>
